import { create } from 'zustand';
import { _storageVersion, _userEmail, _userUniqueId } from '../constants';
import { customStorage } from '../foo';
import { persist, subscribeWithSelector } from 'zustand/middleware';


export interface CardProps {
    index: number;
    width: number;
    height: number | null;
    x: number;
    y: number;
    fontSize: number;
    mainBackgroundColor: string;
    borderColor: string;
    textColor: string;
    labelBackgroundColor: string;
    borderSize: number;
    label: string;
    image: string | null;
    isEditMode: boolean;
    setIsStored: any
}

interface CardsProps {
    [key: string | number ] : CardProps[]
}

interface Path2ArtProps {
    [key: string]: CardsProps;
}

interface ArtState {
    path2art: Path2ArtProps;
    setCardProperty: <T extends keyof CardProps>(path: string, layerIndex: string | number, cardIndex: number, property: T, value: CardProps[T]) => void;
    addCard: (path: string, layerIndex: number, card: CardProps) => void;
    removeAllItemsFromPath: (path: string, layerIndex: string | number) => void;
    setPathItems: (path: string, layerIndex: string | number, items: CardProps[]) => void;
    cardsStates: CardProps[];
    setCardsStates: (cardsStates: CardProps[]) => void;
    selectedCards: number[];
    setSelectedCards: (selectedCards: number[]) => void;


}

const defaultArtState: ArtState = {
    path2art: {},
    setCardProperty: () => {},
    addCard: () => {},
    removeAllItemsFromPath: () => {},
    setPathItems: () => {},
    cardsStates: [],
    selectedCards: [],
    setCardsStates: () => {},
    setSelectedCards: () => {}

};

function replacer(key: string, value: any) {
    if (key === 'ref') {
      // Omit the ref property to avoid circular references in the JSON.stringify 
      // serialization of the state used in the foo.store function
      return undefined;
    }
    return value;
  }

export const useArtStore  = create<ArtState>()(
    subscribeWithSelector(
        persist( 
            (set,get) => ({
                ...defaultArtState,
                
                setCardProperty: (path, layerIndex, cardIndex, property, value) =>
                    set((state) => {
                        const newState = { ...state.path2art };
                        if (!newState[path]) {
                            newState[path] = {};
                        }
                        if (!newState[path][layerIndex]) {
                            newState[path][layerIndex] = [];
                        }
                        const updatedCard = { ...newState[path][layerIndex][cardIndex], [property]: value };
                        newState[path][layerIndex][cardIndex] = updatedCard;
                        return { path2art: newState };
                    }),
                
                addCard: (path, layerIndex, card) =>
                    set((state) => {
                        const newState = { ...state.path2art };
                        if (!newState[path]) {
                            newState[path] = {};
                        }
                        if (!newState[path][layerIndex]) {
                            newState[path][layerIndex] = [];
                        }
                        newState[path][layerIndex].push(card);
                        return { path2art: newState };
                    }),

                removeAllItemsFromPath: (path, layerIndex) =>
                    set((state) => {
                        const newState = { ...state.path2art };
                        if (newState[path]) {
                            delete newState[path][layerIndex];
                        }
                        return { path2art: newState };
                    }),
                setPathItems: (path, layerIndex, items) =>
                    set((state) => {
                        // Serialize with custom replacer to avoid storing refs
                        const stringifiedItems = JSON.stringify(items, replacer);
                        const parsedItems = JSON.parse(stringifiedItems); // Re-parse to use as state
                
                        const newState = { ...state.path2art };
                        if (!newState[path]) {
                            newState[path] = {};
                        }
                        newState[path][layerIndex] = parsedItems;
                        return { path2art: newState };
                    }),
                
                
                setCardsStates: (cardsStates: CardProps[]) => set({ cardsStates }),

                setSelectedCards: (selectedCards: number[]) => set({ selectedCards })


                
            }),  
            {
                    name: "artState",
                    partialize: (state) => ({
                        path2art: state.path2art
                    }),
                    storage: customStorage
                }
        )
    
));
